'use client';

/**
 * ReferralCookieSetter — invisible client component that reads the `?ref=`
 * query param from the URL and persists it as the `profileia_ref` cookie
 * (reusing the existing helper from `@/lib/referral-cookie`).
 *
 * Spec ref: SPEC-094 §1.2 (Cookie de Referido Extendida) — same pattern
 * as `/r/[code]/page.tsx` and `/market` page, applied here so a networker
 * can share `profileia.com/plan-de-compensacion?ref=their_username` and the
 * platform remembers who brought the visitor when they later register.
 *
 * Renders nothing — just runs the side-effect on mount.
 */

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { setReferralCookie } from '@/lib/referral-cookie';

export function ReferralCookieSetter() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref && typeof ref === 'string' && ref.length > 0 && ref.length <= 64) {
      // Basic sanitization: only allow alphanumeric + dash + underscore
      // (referral codes are usernames — same charset as /r/[code]).
      if (/^[a-zA-Z0-9_-]+$/.test(ref)) {
        setReferralCookie(ref);
      }
    }
  }, [searchParams]);

  return null;
}
